import { Injectable } from '@angular/core';
import {
  MatSnackBar, MatSnackBarConfig,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition
} from '@angular/material/snack-bar';
import { isNullOrUndefined } from 'util';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'bottom';
  duration = 4000;
  public config = new MatSnackBarConfig();

  public message: string;
  public action = false;
  public setAutoHide = true;
  public actionButtonLabel: string;

  constructor(public snackBar: MatSnackBar) {
    this.config.verticalPosition = this.verticalPosition;
    this.config.horizontalPosition = this.horizontalPosition;
    this.config.duration = this.setAutoHide ? this.duration : 0;
  }

  showInfo(infoMessage?: string) {

      this.snackBar.open(!isNullOrUndefined(infoMessage) ? infoMessage : this.message,
        this.action ? this.actionButtonLabel : undefined, this.config);
  }

  showError(errorMessage?: string) {
    this.config.panelClass = ['mat-snackbar-danger'];

    this.snackBar.open(!isNullOrUndefined(errorMessage) ? errorMessage : this.message,
      this.action ? this.actionButtonLabel : undefined, this.config);
  }

  showSuccess(successMessage?: string) {

    this.config.panelClass = 'mat-snackbar-success';

    this.snackBar.open(!isNullOrUndefined(successMessage) ? successMessage : this.message,
      this.action ? this.actionButtonLabel : undefined, this.config);
  }
}
